<!--
  @Description 待办事项制单
  @Date 2021-12-22
  @Author liufu
-->
<template>
  <div class="card">
    <el-row>
      <el-col :span="24">
        <div class="buttonContainer">
          <div class="toolbar-dv">
            <toolBarBtn
              :parentData="this"
              :buttonVisible="buttonVisible"
              :moreButtonList="moreButtonList"
              ref="toolBarBtn"
            ></toolBarBtn>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-form
      :model="form"
      ref="FormRef"
      :validate-on-rule-change="false"
      :rules="rules"
      size="small"
    >
      <!-- 第一行 -->
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="主题" prop="subject">
            <el-input
              v-model="form.subject"
              autocomplete="off"
              :placeholder="placeholderConfig.input"
              :disabled="!Authority.edit || dontEdit"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="优先级" prop="priorities">
            <el-select
              clearable
              v-model="form.priorities"
              :placeholder="placeholderConfig.select"
              :disabled="!Authority.edit || dontEdit"
            >
              <el-option
                v-for="i of ComBoxItems.priorities"
                :key="i.name + ''"
                :label="i.name"
                :value="i.value"
              ></el-option>
            </el-select>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="要求完成日期" prop="dueDate">
            <el-date-picker
              v-model="form.dueDate"
              type="date"
              v-date
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :disabled="!Authority.edit || dontEdit"
            ></el-date-picker>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="待办状态" prop="status">
            <el-input
              v-model="form.status"
              autocomplete="off"
              :placeholder="placeholderConfig.relation"
              disabled
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- <el-divider content-position="left">数据列表</el-divider> -->
    <YKDivider content-position="left">明细列表</YKDivider>
    <!-- 菜单权限明细table -->
    <vxe-grid
      ref="xTable"
      size="mini"
      :column-config="{ minWidth: '80px' }"
      border
      keep-source
      :height="tableHeight"
      :cell-class-name="cellClassName"
      resizable
      :edit-rules="validRules"
      show-overflow
      :data="form.detailList"
      highlight-hover-row
      highlight-current-row
      :mouse-config="{ area: true, extension: true }"
      :edit-config="{
        trigger: 'dblclick',
        mode: 'cell',
        activeMethod: activeMethod
      }"
      :keyboard-config="{
        isArrow: true,
        isEnter: true,
        isTab: true,
        isClip: true,
        enterToTab: true,
        isEdit: true,
        editMethod: editMethod
      }"
      :columns="tableColumns"
      :toolbar-config="tableToolbar"
      @toolbar-button-click="toolbarButtonClickEvent"
    >
    </vxe-grid>
    <!-- 角色选择框 -->
    <EmployeeSelect ref="EmployeeSelect" @sureBackPerson="sureBackPerson" />
  </div>
</template>

<script>
export default {
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {
          Authority: {
            edit: false,
            see: false
          }
        }
      }
    },
    joinID: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      id: 0,
      // 表单
      form: {
        subject: '',
        priorities: '',
        status: '',
        dueDate: '',
        id: 0,
        dStatus: '',
        writer: '',
        writerID: 0,
        writeDate: '',
        detailList: []
      },
      // 校验规则
      rules: {
        subject: [
          { required: true, message: '请输入主题', trigger: 'change' }
        ],
        priorities: [
          { required: true, message: '请选择优先级', trigger: 'change' }
        ],
        dueDate: [
        ],
      },
      // 下拉框
      ComBoxItems: {
        priorities: [],
      },
      // 校验
      validRules: {
        person: [
          { required: true, message: '请选择负责人', trigger: 'change' },
        ],
        content: []
      },
      // 动态列
      tableColumns: [],
      errIndex: [],
      // tabel工具栏
      tableToolbar: {
        buttons: [
          {
            code: 'pickMan',
            name: '选择员工',
            disabled: true
          },
        ]
      },
      // 右键缓存
      areas: {},
      colProperty: '',
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      buttonVisible: {
        add: false,
        save: false,
        delete: false,
        update: false,
        refresh: false,
        search: false,
        sort: false,
        lock: false,
        unlock: false,
        more: false
      },
      moreButtonList: [
        {
          name: '保存',
          icon: 'el-icon-folder-checked',
          disabled: true,
          event: 'save'
        },
        {
          name: '删除',
          icon: 'el-icon-delete',
          disabled: true,
          event: 'delete'
        },
        {
          name: '返回',
          icon: 'iconfont fjyk-back',
          disabled: true,
          event: 'back'
        },
      ],
      ifAdd: false,
      // 是否绑定完成
      IfDataBindComplete: false,
      // 是否不能编辑
      dontEdit: true
    }
  },
  created () {
    this.InitColumn()
    this.BindComBox()
    this.id = this.joinID ? this.joinID : 0
    this.BindText()
  },
  mounted () {
  },
  methods: {
    // 获取权限
    InitRight () {
      this.dontEdit = Boolean(this.form.writerID && this.form.writerID !== this.$store.state.userInfo.userId)
      this.tableToolbar = {
        buttons: [
          {
            code: 'pickMan',
            name: '选择员工',
            disabled: !this.Authority.edit || this.dontEdit,
          }
        ]
      }
      this.moreButtonList = [
        {
          name: '保存',
          icon: 'el-icon-folder-checked',
          disabled: !this.Authority.edit || this.dontEdit,
          event: 'save'
        },
        {
          name: '删除',
          icon: 'el-icon-delete',
          disabled: this.id === 0 || !this.Authority.edit || this.dontEdit,
          event: 'delete'
        },
        {
          name: '取消待办',
          icon: 'el-icon-circle-close',
          disabled: this.id === 0 || this.form.status === '取消' || this.dontEdit,
          event: 'handleCancleMain'
        },
        {
          name: '恢复待办',
          icon: 'el-icon-refresh-right',
          disabled: this.id === 0 || this.form.status !== '取消' || this.dontEdit,
          event: 'handleRecoveryMain'
        },
        {
          name: '确认完成',
          icon: 'el-icon-success',
          disabled: this.id === 0 || ['已完成', '/'].includes(this.form.dStatus),
          event: 'handleConfirm'
        },
        {
          name: '取消确认完成',
          icon: 'el-icon-error',
          disabled: this.id === 0 || ['未完成', '/'].includes(this.form.dStatus),
          event: 'handleCancleConfirm'
        },
        {
          name: '返回',
          icon: 'iconfont fjyk-back',
          disabled: false,
          event: 'back'
        },
      ]
      this.InitColumn()
    },
    // 返回excel
    sureImportBack (List) {
      if (List.length > 0) {
        for (let item of List) {
          this.$refs.xTable.insertAt(item)
        }
        this.IfExistModify = true
      }
    },
    // 批量输入返回
    sureBackBatch (str) {
      this.areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            if (col.property === this.colProperty) {
              row[this.colProperty] = str
            }
          }
        }
      })
    },
    save () {
      this.validEnter().then(async result => {
        if (result) {
          if (this.id && this.id > 0) {
            this.update()
          } else {
            this.add()
          }
        }
      })
    },
    // 新增
    async add () {
      let form = { ...this.form }
      let insertRecords = this.$refs.xTable.getInsertRecords()
      form.detailList = insertRecords
      form = this.removeObjectNull(form)
      form.detailList = this.removeArrayNull(form.detailList)
      const { data: res } = await this.$http.post('/Common/YKToDoList/both', form)
      if (res.isSuccess) {
        this.id = res.data
        this.$message.success(this.messageConfig.save.success)
        // this.IfExistModify = false
        this.ifAdd = true
        this.BindText()
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 修改
    async update () {
      let form = { ...this.form }
      let insertRecords = this.$refs.xTable.getInsertRecords()
      let removeRecords = this.$refs.xTable.getRemoveRecords()
      let updateRecords = this.$refs.xTable.getUpdateRecords()
      form.detailList = []
      for (let item of insertRecords) {
        form.detailList.push(item)
      }
      for (let item of removeRecords) {
        item.id = item.id > 0 ? 0 - item.id : item.id
        form.detailList.push(item)
      }
      for (let item of updateRecords) {
        form.detailList.push(item)
      }
      form = this.removeObjectNull(form)
      form.detailList = this.removeArrayNull(form.detailList)
      const { data: res } = await this.$http.put('/Common/YKToDoList/both', form)
      if (res.isSuccess) {
        this.$message.success(this.messageConfig.save.success)
        // this.IfExistModify = false
        this.BindText()
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 验证
    async validEnter () {
      let flag = true
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      this.errIndex = []
      const errMap = await this.$refs.xTable.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              this.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex
              })
            })
          })
        })
        if (this.errIndex.length > 0) {
          flag = false
        }
      }
      if (this.$refs.xTable.getTableData().fullData.length === 0) {
        this.$XModal.alert({
          message: this.messageConfig.blankDetail,
          status: 'warning'
        })
        return false
      }
      // 重复行
      // this.repeatForTable(this.errIndex, this.$refs.xTable, ['groupName', 'vuePath'])
      // if (this.errIndex.length > 0) {
      //   flag = false
      //   this.$message.error('验证失败,请核对输入数据')
      //   return false
      // }
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 获取数据
    async BindText () {
      this.IfDataBindComplete = false
      if (this.id > 0) {
        const { data: res } = await this.$http.get('/Common/YKToDoList/both', {
          params: {
            id: this.id
          }
        })
        if (!res.isSuccess) {
          this.$message.error(res.errorMessage)
          return false
        }
        this.form = res.data
      } else {
        this.form = {
          subject: '',
          priorities: '',
          status: '',
          dueDate: '',
          id: 0,
          detailList: []
        }
      }
      this.InitRight()
      this.$nextTick(() => {
        this.IfDataBindComplete = true
        this.IfExistModify = false
      })
    },
    // table 点击删除列
    delete () {
      this.$confirm('确定要删除本张单据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.sureDelete()
        })
        .catch(() => { })
    },
    async sureDelete () {
      const that = this
      const { data: res } = await that.$http.delete(
        '/Common/YKToDoList', {
        data: {
          id: that.id,
          effectCondition: that.Authority.alEffectCondition,
          empower: []
        }
      })
      if (res.isSuccess) {
        that.$message.success(that.messageConfig.del.success)
        that.IfExistModify = false
        that.back('del')
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    back (type) {
      if (this.IfExistModify) {
        this.$confirm('您已做出修改，是否关闭？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            if (this.ifAdd) {
              this.$emit('SingleBack', -1)
            } else {
              switch (type) {
                case 'del':
                  this.$emit('SingleBack', -1)
                  break
                default:
                  this.$emit('SingleBack', this.id)
                  break
              }
            }
          })
          .catch(() => {
          })
      } else {
        if (this.ifAdd) {
          this.$emit('SingleBack', -1)
        } else {
          switch (type) {
            case 'del':
              this.$emit('SingleBack', -1)
              break
            default:
              this.$emit('SingleBack', this.id)
              break
          }
        }
      }
    },
    // 绑定下拉框
    async BindComBox () {
      this.ComBoxItems.priorities = []
      const { data: selectRes } = await this.$http.get('/Common/YKToDoList/select-item')
      if (selectRes.isSuccess) {
        for (let item of selectRes.data) {
          if (item.code === 'priorities') {
            this.ComBoxItems.priorities.push({
              name: item.name,
              value: Number(item.value)
            })
          }
        }
      }
    },
    // 初始化
    InitColumn () {
      this.tableColumns = [
        {
          type: 'seq',
          width: '50'
        },
        { field: 'delete', title: '删除', visible: this.Authority.edit && !this.dontEdit, width: '50', align: 'center', slots: { default: ({ row }) => { return [<i id="vxeDelete" class="el-icon-delete-solid" onClick={() => { this.removeRowForTable(row, this.$refs.xTable, this.$data) }} ></i>] } } },
        {
          field: 'person',
          title: '负责人',
          editRender: { name: '$input', attrs: { disabled: true } }
        },
        {
          field: 'content',
          title: '负责内容',
          editRender: { name: "input" }
        },
        {
          field: 'status',
          title: '完成状态',
        },
        {
          field: 'completeTime',
          title: '完成日期',
          formatter: ['formatDate', 'yyyy-MM-dd']
        }
      ]
    },
    // 单元格设置样式,错误提示
    cellClassName ({ row, columnIndex }) {
      var a = this.errIndex.find(item => {
        return item._XID === row._XID && item.columnIndex === columnIndex
      })
      if (a) {
        return 'cell-valid'
      }
    },
    // cell激活控制
    activeMethod ({ column }) {
      if (
        column.editRender &&
        column.editRender.attrs &&
        column.editRender.attrs.disabled === true
      ) {
        return false
      }
      if (!this.Authority.edit || this.dontEdit) {
        return false
      }
      return true
    },
    // cell编辑控制
    editMethod ({ row, column, $table }) {
      if (
        column.editRender &&
        column.editRender.attrs &&
        column.editRender.attrs.disabled === true
      ) {
        return false
      }
      if (!this.Authority.edit || this.dontEdit) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },
    // table工具栏方法
    toolbarButtonClickEvent ({ code }) {
      switch (code) {
        case 'pickMan':
          this.handlePickMan()
          break
      }
    },
    // 选择员工
    handlePickMan () {
      this.$refs.EmployeeSelect.formVisible = true
    },
    // 返回人员
    sureBackPerson (list) {
      if (list.length > 0) {
        const tableData = this.$refs.xTable.getTableData().fullData
        for (let item of list) {
          const option = tableData.filter(i => {
            return Number(i.personID) === Number(item.id)
          })
          if (option.length === 0) {
            this.$refs.xTable.insertAt(
              {
                person: item.name,
                personID: item.id
              }, -1)
          }
        }
      }
    },
    // 取消待办
    handleCancleMain () {
      this.cancleOrRecoveryMain(this.id, '取消')
    },
    // 恢复待办
    handleRecoveryMain () {
      this.cancleOrRecoveryMain(this.id, '恢复')
    },
    // 确认完成
    handleConfirm () {
      this.confirmOrCancle(this.id, '完成')
    },
    // 取消确认完成
    handleCancleConfirm () {
      this.confirmOrCancle(this.id, '取消完成')
    },
    // 取消完成或确认完成待办
    async confirmOrCancle (id, type) {
      const { data: res } = await this.$http.put('/Common/YKToDoList/confirmOrCancle', {
        id: id,
        type: type
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('操作成功!')
      this.BindText()
    },
    // 取消或恢复待办
    async cancleOrRecoveryMain (id, type) {
      const { data: res } = await this.$http.put('/Common/YKToDoList/cancleOrRecovery', {
        id: id,
        type: type
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('操作成功!')
      this.BindText()
    },
  },
  computed: {
    tableHeight () {
      const headerHeight = 80
      const cardMaring = 15 * 2
      const cardPadding = 10 * 2
      const button = 40
      const elForm = 65
      const divider = this.$store.state.ykDivider
      return Number(this.$store.state.clientHeight) -
        headerHeight - cardMaring - cardPadding - elForm -
        divider - button
    },
  },
  watch: {
    form: {
      handler () {
        if (this.IfDataBindComplete) {
          this.IfExistModify = true
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
@main-margin: 15px;
.card {
  height: calc(100vh - @header-height - (@main-margin * 2));
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 10px;
}
.buttonContainer {
  width: 100%;
  // display: flex;
  // justify-content: center;
}
</style>
